export class TrackByUtils {
  public static trackByIndex(index: number): number {
    return index;
  }

  public static trackById<T extends { id: string | number }>(_: number, item: T): string | number {
    return item.id;
  }
}
